<template>
  <div>
    <b-modal
      id="modal-organization"
      ref="modal_organization"
      :title="title"
      size="xl"
      lazy
      centered
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      @hidden="onHidden"
    >
      <b-skeleton-wrapper :loading="isBusy">
        <template #loading>
          <b-form>
            <b-card bg-variant="light">
              <!-- ИНН, КПП, ОГРН -->
              <b-row class="mt-2">
                <b-col>
                  <b-skeleton width="10%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="10%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="10%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
              </b-row>
              <!-- Заполнить данными -->
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="16%" height="115%"/>
                </b-col>
              </b-row>
              <!--Сокращённое, полное наименование заказчика -->
              <b-row>
                <b-col>
                  <b-skeleton width="20%" height="17%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="29%" class="mb-2"/>
                  <b-skeleton width="30%" height="13%"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-skeleton width="15%" height="17%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="29%" class="mb-2"/>
                  <b-skeleton width="26%" height="13%"/>
                </b-col>
              </b-row>
              <!-- Адрес, Телефон, Примечание -->
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="4%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="6%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
              </b-row>
              <b-row class="mb-5">
                <b-col>
                  <b-skeleton width="9%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="104%"/>
                </b-col>
              </b-row>
              <!-- Банковские реквизиты -->
              <b-row class="mb-1">
                <b-col>
                  <b-skeleton width="15%" height="55%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="6%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="49%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col>
                  <b-skeleton width="19%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="28%" height="26%" class="mb-2"/>
                  <b-skeleton type="input" height="41%"/>
                </b-col>
              </b-row>
              <!-- Руководители организации или ИП -->
              <b-row class="mb-0">
                <b-col>
                  <b-skeleton width="35%" height="50%" class="mb-2"></b-skeleton>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="43%" height="21%" class="mb-2"/>
                  <b-skeleton type="input" height="50%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="26%" height="21%" class="mb-2"/>
                  <b-skeleton type="input" height="50%"/>
                </b-col>
              </b-row>
            </b-card>
          </b-form>
        </template>

        <template #default>
          <b-form>
            <b-card bg-variant="light">
              <b-row cols="3">
                <b-col>
                  <b-form-group id="group-inn" :label="$t('message.organizations.modal.inn')">
                    <b-form-input
                      type="text"
                      size="sm"
                      :disabled="isDisabled"
                      :state="getFieldState('inn')"
                      placeholder="Введите ИНН"
                      v-model="newItem.inn"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="group-kpp" :label="$t('message.organizations.modal.kpp')">
                    <b-form-input
                      type="text"
                      size="sm"
                      :disabled="isDisabled"
                      placeholder="Введите КПП"
                      v-model="newItem.kpp"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="group-ogrn" :label="$t('message.organizations.modal.ogrn')">
                    <b-form-input
                      type="text"
                      size="sm"
                      :disabled="isDisabled"
                      placeholder="Введите ОГРН"
                      v-model="newItem.ogrn"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-button size="sm" class="mb-2" :disabled="isEmpty(newItem.inn) || isDisabled" variant="secondary" @click="findCustomerData()">
                <font-awesome-icon icon="file-signature" class="mr-1"/>
                Заполнить данными
              </b-button>

              <b-form-group id="group-name" :label="$t('message.organizations.modal.nameInput')"
                :description="$t('message.organizations.modal.nameInputDescription')"
              >
                <b-form-input
                  type="text"
                  size="sm"
                  :disabled="isDisabled"
                  :state="getFieldState('name')"
                  v-model="newItem.name"
                />
              </b-form-group>

              <b-form-group id="group-full-name" :label="$t('message.organizations.modal.fullNameInput')"
                :description="$t('message.organizations.modal.fullNameInputDescription')"
              >
                <b-form-input
                  type="text"
                  size="sm"
                  :disabled="isDisabled"
                  v-model="newItem.full_name"
                />
              </b-form-group>

              <b-form-group id="group-address" :label="$t('message.organizations.modal.addressInput')">
                <b-form-input
                  type="text"
                  size="sm"
                  :disabled="isDisabled"
                  :placeholder="$t('message.organizations.modal.addressPlaceholder')"
                  v-model="newItem.address"
                />
              </b-form-group>

              <b-form-group id="group-phone" :label="$t('message.organizations.modal.phoneInput')">
                <b-form-input
                  type="text"
                  size="sm"
                  :disabled="isDisabled"
                  :placeholder="$t('message.organizations.modal.phonePlaceholder')"
                  aria-describedby="inputLiveFeedbackPhone"
                  v-model="newItem.phone"
                />
                <b-form-invalid-feedback id="inputLiveFeedbackPhone">
                  {{ $t("message.organizations.modal.phoneError") }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="group-description" :label="$t('message.organizations.modal.descriptionInput')">
                <b-form-textarea
                  size="sm"
                  :disabled="isDisabled"
                  :placeholder="$t('message.organizations.modal.descriptionPlaceholder')"
                  v-model="newItem.description"
                  :rows="3"
                  :max-rows="6"
                />
              </b-form-group>
              <h6>Банковские реквизиты</h6>
              <b-row cols="2">
                <b-col>
                  <b-form-group id="group-bik" :label="$t('message.organizations.modal.bik')">
                    <b-form-input
                      size="sm"
                      autocomplete="off"
                      :disabled="isDisabled"
                      v-model="newItem.bik"
                    />
                  </b-form-group>

                  <b-form-group id="group-cor-account" :label="$t('message.organizations.modal.cor_account')">
                    <b-form-input
                      size="sm"
                      autocomplete="off"
                      :disabled="isDisabled"
                      v-model="newItem.cor_account"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="group-bank" :label="$t('message.organizations.modal.bank')">
                    <b-form-input
                      id="input-bank"
                      size="sm"
                      autocomplete="off"
                      :disabled="isDisabled"
                      v-model="newItem.bank"
                    />
                  </b-form-group>

                  <b-form-group id="group-checking-account" :label="$t('message.organizations.modal.checking_account')">
                    <b-form-input
                      id="input-checking-account"
                      size="sm"
                      autocomplete="off"
                      :disabled="isDisabled"
                      v-model="newItem.checking_account"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <h6>Руководители организации или ИП для документов</h6>
              <b-row cols="2">
                <b-col>
                  <b-form-group id="group-director" :label="$t('message.organizations.modal.director')">
                    <b-form-input
                      size="sm"
                      autocomplete="off"
                      :disabled="isDisabled"
                      v-model="newItem.director"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="group-accountant" :label="$t('message.organizations.modal.accountant')">
                    <b-form-input
                      size="sm"
                      autocomplete="off"
                      :disabled="isDisabled"
                      v-model="newItem.accountant"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <h6>Интеграции</h6>
              <b-row>
                <b-col>
                  <b-form-group id="group-balans-pro" label="Баланс Про API токен">
                    <b-form-input
                      size="sm"
                      autocomplete="off"
                      :disabled="isDisabled"
                      v-model="balansProApiToken"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <br/>
              <b-link class="text-decoration-none" v-b-toggle:stamp-collapse>
                <span class="when-open"><font-awesome-icon icon="chevron-up"/></span>
                <span class="when-closed"><font-awesome-icon icon="chevron-down"/></span>
                <font-awesome-icon icon="stamp"/> Логотип, печать, подписи
              </b-link>
              <b-collapse id="stamp-collapse">
                <p class="mt-2 text-small text-danger">Все файлы должны быть соответствующего размера в форматах <b>.jpeg</b> или <b>.png</b></p>
                <b-row class="mt-2 mb-2">
                  <b-col>
                    <b-card no-body class="text-center">
                      <b-card-header>
                        Лого (54x27 мм)
                      </b-card-header>
                      <b-card-body>
                        <b-img thumbnail width="100" height="100" :src=logoBlobURL></b-img>
                      </b-card-body>
                      <b-card-footer>
                        <b-list-group horizontal>
                          <b-form-file :disabled="isDisabled" size="sm" class="mr-1" v-model="logoFile" accept="image/jpeg, image/png" browse-text="Выбрать" placeholder="Файл не выбран"/>
                          <b-button :disabled="isDisabled" size="sm" variant="danger" @click="onRemove('logoFile')">
                            <font-awesome-icon icon="times"/>
                          </b-button>
                        </b-list-group>
                      </b-card-footer>
                    </b-card>
                  </b-col>
                  <b-col>
                    <b-card no-body class="text-center">
                      <b-card-header>
                        Печать (40x40 мм)
                      </b-card-header>
                      <b-card-body>
                        <b-img thumbnail width="100" height="100" :src=stampBlobURL></b-img>
                      </b-card-body>
                      <b-card-footer>
                        <b-list-group horizontal>
                          <b-form-file :disabled="isDisabled" size="sm" class="mr-1" v-model="stampFile" accept="image/jpeg, image/png" browse-text="Выбрать" placeholder="Файл не выбран"/>
                          <b-button :disabled="isDisabled" size="sm" variant="danger" @click="onRemove('stampFile')">
                            <font-awesome-icon icon="times"/>
                          </b-button>
                        </b-list-group>
                      </b-card-footer>
                    </b-card>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-card no-body class="text-center">
                      <b-card-header>
                        Подпись руководителя (34x16 мм)
                      </b-card-header>
                      <b-card-body>
                        <b-img thumbnail width="100" height="100" :src=directorSignBlobURL></b-img>
                      </b-card-body>
                      <b-card-footer>
                        <b-list-group horizontal>
                          <b-form-file :disabled="isDisabled" class="mr-1" size="sm" v-model="directorSignFile" accept="image/jpeg, image/png" browse-text="Выбрать" placeholder="Файл не выбран"/>
                          <b-button :disabled="isDisabled" size="sm" variant="danger" @click="onRemove('directorSignFile')">
                            <font-awesome-icon icon="times"/>
                          </b-button>
                        </b-list-group>
                      </b-card-footer>
                    </b-card>
                  </b-col>
                  <b-col>
                    <b-card no-body class="text-center">
                      <b-card-header>
                        Подпись бухгалтера (34x16 мм)
                      </b-card-header>
                      <b-card-body>
                        <b-img thumbnail width="100" height="100" :src=accountantSignBlobURL></b-img>
                      </b-card-body>
                      <b-card-footer>
                        <b-list-group horizontal>
                          <b-form-file :disabled="isDisabled" size="sm" class="mr-1" v-model="accountantSignFile" accept="image/jpeg, image/png" browse-text="Выбрать" placeholder="Файл не выбран"/>
                          <b-button :disabled="isDisabled" size="sm" variant="danger" @click="onRemove('accountantSignFile')">
                            <font-awesome-icon icon="times"/>
                          </b-button>
                        </b-list-group>
                      </b-card-footer>
                    </b-card>
                  </b-col>
                  <b-col>
                    <b-card no-body class="text-center">
                      <b-card-header>
                        Подпись ИП (34x16 мм)
                      </b-card-header>
                      <b-card-body>
                        <b-img thumbnail width="100" height="100" :src=individualSignBlobURL></b-img>
                      </b-card-body>
                      <b-card-footer>
                        <b-list-group horizontal>
                          <b-form-file :disabled="isDisabled" size="sm" class="mr-1" v-model="individualSignFile" accept="image/jpeg, image/png" browse-text="Выбрать" placeholder="Файл не выбран"/>
                          <b-button :disabled="isDisabled" size="sm" variant="danger" @click="onRemove('individualSignFile')">
                            <font-awesome-icon icon="times"/>
                          </b-button>
                        </b-list-group>
                      </b-card-footer>
                    </b-card>
                  </b-col>
                </b-row>
              </b-collapse>
            </b-card>
          </b-form>
        </template>
      </b-skeleton-wrapper>

      <template>
        <div class="w-100 d-flex justify-content-end py-2">
          <b-button size="sm" variant="secondary" class="mr-2" @click="handleCancel">
            Отменить
          </b-button>
          <b-button size="sm" variant="success" :disabled="isDisabled || loading" @click="handleOk">
            <b-spinner v-if="loading" small/>
            <font-awesome-icon icon="save" class="mr-1"/>
            Сохранить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import organizations from "../../network/organizations";
import balansPro from "../../network/balansPro";
  import helpers from "../../utilites/helpers";

export default {
  name: "Organization",
  mixins: [
    organizations, balansPro,
    helpers
  ],
  data() {
    return {
      title:'Организация',
      formUrl: 'organizations',
      newItem: this.setNewItem(),
      deleteRow: {
        id: null,
        name: '',
      },
      isDisabled: true,
      isBusy: false,
      loading: false,
      isBusyStamps: false,
      logoFile: null,
      stampFile: null,
      directorSignFile: null,
      accountantSignFile: null,
      individualSignFile: null,
      balansProApiToken: null,
    }
  },
  computed: {
    logoBlobURL() {
      return this.blobURLFromFile(this.logoFile);
    },
    stampBlobURL() {
      return this.blobURLFromFile(this.stampFile);
    },
    directorSignBlobURL() {
      return this.blobURLFromFile(this.directorSignFile);
    },
    accountantSignBlobURL() {
      return this.blobURLFromFile(this.accountantSignFile);
    },
    individualSignBlobURL() {
      return this.blobURLFromFile(this.individualSignFile);
    },
  },
  methods: {
    setNewItem() {
      this.logoFile = null;
      this.stampFile = null;
      this.directorSignFile = null;
      this.accountantSignFile = null;
      this.individualSignFile = null;
      this.balansProApiToken = null;

      return {
        id: null,
        name: '',
        phone: '',
        address: '',
        active: true,
        description: '',
        inn: '',
        kpp: '',
        ogrn: '',
        full_name: '',
        bik: '',
        bank: '',
        cor_account: '',
        checking_account: '',
        director: '',
        accountant: '',
        stamp: {
          id: 0,
          logo: '',
          stamp: '',
          director_sign: '',
          accountant_sign: '',
          individual_sign: '',
        },
      }
    },
    async showModal(organizationId, isView) {
      this.isDisabled = isView;
      this.newItem = this.setNewItem();
      this.$refs.modal_organization.show();

      if (organizationId) {
        await this.getOrganization(organizationId);
      }
    },
    hideModal() {
      this.$refs.modal_organization.hide();
    },
    handleOk() {
      this.handleSubmit();
    },
    handleCancel() {
      this.hideModal();
    },
    onHidden() {
      this.$emit('modal-closed');
    },
    async getOrganization(organizationId) {
      this.isBusy = true;
      this.loading = true;

      const result = await this.getOrganizationById(organizationId);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.newItem = result.data;

      this.isBusyStamps = true;
      await this.getOrganizationStumps(this.newItem.id);
      this.isBusyStamps = false;
      this.isBusy = false;
      this.loading = false;

      await this.getBalansProApiToken();
    },
    async getOrganizationStumps(organizationId) {
      const stampsResult = await this.getStamps(organizationId);

      if (stampsResult.data !== null) {
        this.newItem.stamp = stampsResult.data;

        if (this.newItem.stamp.logo !== '') {
          const fileName = this.newItem.stamp.logo.split("/").pop();
          const result = await this.getOrganizationFile(this.newItem.id, "logo");
          this.logoFile = new File([result.data], fileName);
        }
        if (this.newItem.stamp.stamp !== '') {
          const fileName = this.newItem.stamp.logo.split("/").pop();
          const result = await this.getOrganizationFile(this.newItem.id, "stamp");
          this.stampFile = new File([result.data], fileName);
        }
        if (this.newItem.stamp.director_sign !== '') {
          const fileName = this.newItem.stamp.logo.split("/").pop();
          const result = await this.getOrganizationFile(this.newItem.id, "director");
          this.directorSignFile = new File([result.data], fileName);
        }
        if (this.newItem.stamp.accountant_sign !== '') {
          const fileName = this.newItem.stamp.logo.split("/").pop();
          const result = await this.getOrganizationFile(this.newItem.id, "accountant");
          this.accountantSignFile = new File([result.data], fileName);
        }
        if (this.newItem.stamp.individual_sign !== '') {
          const fileName = this.newItem.stamp.logo.split("/").pop();
          const result = await this.getOrganizationFile(this.newItem.id, "individual");
          this.individualSignFile = new File([result.data], fileName);
        }
      }
    },
    async handleSubmit() {
      const submitValidation = [
        { item: 'inn', message: 'Укажите ИНН.' },
        { item: 'name', message: 'Укажите сокращённое наименование заказчика.' },
      ];

      for (const validation of submitValidation) {
        if (!this.newItem[validation.item]) {
          this.showSubmitError(validation.message);
          return;
        }
      }

      this.loading = true;

      const data = { ...this.newItem };

      const method = (data.id > 0) ? this.putOrganization : this.postOrganization;
      const result = await method(data);

      if (result.status === 422) {
        this.showSubmitError("Организация с таким ИНН уже существует. Найдите его в базе или введите корректный ИНН.");
        this.loading = false;
        return;
      }

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.loading = false;
        return;
      }

      this.newItem.id = result.data.id;

      await this.sendFiles(this.newItem.id);

      this.loading = false;
      this.$emit('refresh');
      this.hideModal();
    },
    getFieldState(field) {
      const value = this.newItem[field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'number') {
        return value > 0;
      }

      return !!value;
    },
    // Files
    async sendFiles(organizationId) {
      let formData = new FormData();
      if (this.logoFile) {
        const type = "logo";
        const fileName = this.getFileName(this.logoFile, type);
        formData.append(type, this.logoFile, fileName);
      }

      if (this.stampFile) {
        const type = "stamp";
        const fileName = this.getFileName(this.stampFile, type);
        formData.append(type, this.stampFile, fileName);
      }

      if (this.directorSignFile) {
        const type = "director";
        const fileName = this.getFileName(this.directorSignFile, type);
        formData.append(type, this.directorSignFile, fileName);
      }

      if (this.accountantSignFile) {
        const type = "accountant";
        const fileName = this.getFileName(this.accountantSignFile, type);
        formData.append(type, this.accountantSignFile, fileName);
      }

      if (this.individualSignFile) {
        const type = "individual";
        const fileName = this.getFileName(this.individualSignFile, type);
        formData.append(type, this.individualSignFile, fileName);
      }

      const filesResult = await this.postOrganizationFiles(organizationId, formData)

      if (filesResult.error) {
        this.showSubmitError("Ошибка отправки файлов.");
      }
    },
    onRemove(fileType) {
      const title = "Удаление файла";
      const message = "Вы действительно хотите удалить этот файл?";
      this.showModalDelete(title, message, async () => {
        this[fileType] = null;
      });
    },
    getFileName(file, type) {
      const ext = "." + file.name.split('.').pop();
      return type + ext;
    },
    findCustomerData() {
      const url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party";
      const token = "31beeee7ca170c466dc8afe98a1fee6f391d4016";
      const query = this.newItem.inn; //7840062125

      const options = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Token " + token
        },
        body: JSON.stringify({query: query})
      };

      fetch(url, options)
        .then(response => response.json())
        .then(result =>  {
          const suggestions = result.suggestions;
          if (suggestions) {
            const organization = suggestions[0]
            if (organization) {
              this.newItem.inn = organization.data.inn;
              this.newItem.kpp = organization.data.kpp;
              this.newItem.ogrn = organization.data.ogrn;
              this.newItem.name = organization.data.name.short_with_opf;
              this.newItem.full_name = organization.data.name.full_with_opf;
              this.newItem.address = organization.data.address.value;
            } else {
              this.showSubmitError("Данные по ИНН не найдены.");
            }
          }
        })
        .catch(error => console.log("error", error));
    },
    blobURLFromFile(file) {
      if (file !== null) {
        return URL.createObjectURL(file);
      }
      return '';
    },
    // Integration
    async getBalansProApiToken() {
      const data = {
        organization_id: this.newItem.id,
      }
      const result = await this.getBalansProOrganizationIntegration(data);

      if (result.data == null) {
        this.balansProApiToken = null;
        return;
      }

      this.balansProApiToken = result.data.balans_pro_org_token;
    },
    async createBalansProApiToken(organization_id) {
      if (this.balansProApiToken == null) {
        return;
      }

      const data = {
        organization_id: organization_id,
        balans_pro_org_token: this.balansProApiToken,
      }

      await this.createBalansProOrganizationIntegration(data);
    },
    async updateBalansProApiToken(organization_id) {
      const getData = {
        organization_id: this.newItem.id,
      }
      const getResult = await this.getBalansProOrganizationIntegration(getData);

      if (getResult.data == null) {
        await this.createBalansProApiToken(organization_id);
        return;
      }

      if (this.balansProApiToken == null) {
        return;
      }

      const data = {
        id: getResult.data.id,
        organization_id: organization_id,
        balans_pro_org_token: this.balansProApiToken,
      }

      await this.updateBalansProOrganizationIntegration(data);
    },

  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Organizations/Organization.vue